module.exports = "../../app/cells/components/modals/setup_wizard/welcome.erb";